export default __webpack_public_path__ + "static/media/01_north_flower_b2.2837fee5.mp4";